var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-icon"},[_c(_vm.tags.tag,_vm._b({tag:"component",staticClass:"node-img"},'component',_vm.tags.attrs,false)),_c('span',{staticClass:"node-text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }